import React, { lazy, Suspense } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./components/Contexts/Auth";
import RequireAuth from "./components/Contexts/RequireAuth";
import LayoutBasic from "./layouts/LayoutBasic";
import Login from "./pages/Login";
import RequestPassword from "./pages/RequestPassword";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";

const OSPanel = lazy(() => import("./pages/OSPanel"));
const OrderView = lazy(() => import("./pages/OrderView"));
const AddCollaborators = lazy(() => import("./pages/AddCollaborators"));
const AddBms = lazy(() => import("./pages/AddBms"));
const AddInvoice = lazy(() => import("./pages/AddInvoice"));

const privateRoutes = [
  { path: "/os-panel", Component: OSPanel },
  { path: "/order-view", Component: OrderView },
  { path: "/add-collaborators", Component: AddCollaborators },
  { path: "/add-bms", Component: AddBms },
  { path: "/add-invoice", Component: AddInvoice },
];

function PrivateLayout() {
  return (
    <RequireAuth>
      <LayoutBasic>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </LayoutBasic>
    </RequireAuth>
  );
}

export default function RouteMap() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/request-password" element={<RequestPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route element={<PrivateLayout />}>
          <Route index element={<OSPanel />} />
          {privateRoutes.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}
